export default __webpack_public_path__ + "static/media/circle_one.1b8a4519.svg";